import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { NotificationManager } from 'react-notifications'
import ReportBtnForArr from '../../../../components/Buttons/ReportsBtn/ReportBtnForArr'
import getFiscalDoc from '../utils/getFiscalDoc'
import { WKF_BASE_URL } from '../../../../config/config'

export default function WN(WN, idx, state, setState) {
  const date = WN.CreateDateTime;

  return (
    <tr key={idx}>
      <td>
        <div className="d-flex align-items-center">
          <Link className={'btn text-nowrap btn-sm btn-info'}>
            {WN.FiscalDocType}
          </Link>
        </div>
      </td>
      <td>
        <div>{WN.NrUnik}</div>
        <div>{WN.NrEwid}</div>
      </td>
      <td>
        <div>{date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '-'}</div>
      </td>
      <td colSpan={2}>
        <div>
          <div>Dokument niefiskalny</div>
          {WN.JPKID ? <div>JPK ID: {WN.JPKID}</div> : null}
        </div>
      </td>
      <td>
        <ReportBtnForArr
          state={state}
          setState={setState}
          value={{ Report: 1, Id: WN.FiscalDocId }}
          btnColor="primary"
          clickFnc={() => getFiscalDoc(WN, setState)}
        />
        <button
          onClick={() => {
            try {
              window.navigator.clipboard.writeText(
                `${WKF_BASE_URL}/wkf/params?nrunik=${WN.NrUnik}&fiscaldoc=${WN.Hash}&client=${sessionStorage.getItem('clientId')}`
              )
              NotificationManager.success('Link copied to clipboard')
            } catch (e) {
              NotificationManager.error(e)
            }
          }}
          className={`d-inline m-1 btn btn-info float-right fas fa-xs fa-copy`}
        ></button>
      </td>
    </tr>
  )
}
